import { inject, Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { DialogService } from '@marmon/frontend/common';
import { ConfirmDialogComponent } from '@marmon/frontend/components';
import { PolymorpheusComponent } from '@taiga-ui/polymorpheus';
import { map, Observable, of } from 'rxjs';
import { AnalysisApiService } from '../services';

export interface ComponentCanDeactivate {
	canDeactivate: () => boolean | Observable<boolean>;
}

@Injectable({ providedIn: 'root' })
export class ActiveCalculationGuard implements CanDeactivate<ComponentCanDeactivate> {
	readonly analysisApiService = inject(AnalysisApiService);
	readonly dialog = inject(DialogService);

	readonly confirmationDialog = () =>
		this.dialog.open(
			new PolymorpheusComponent(ConfirmDialogComponent),
			ConfirmDialogComponent.Options({
				label: 'analyses.dialog.loading-calculation-warning.label',
				data: {
					acceptText: 'action.continue',
					cancelText: 'action.cancel',
					description:
						'analyses.dialog.loading-calculation-warning.description',
				},
			}),
		);

	canDeactivate(): Observable<boolean> {
		const loadingCalculation =
			this.analysisApiService.loadingCalculation$.value;

		if (loadingCalculation && !loadingCalculation.endedAt) {
			return this.confirmationDialog().pipe(map((res) => !!res));
		}

		return of(true);
	}
}
